<template>
  <div class="flex items-center">
    <!--<vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />-->
    <router-link v-if="params.data.isactive == true || !canAccessInvoice" :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link>
    <router-link v-else :to='urlnull' class="text-inherit hover:text-alert">{{ params.value }}</router-link>
  </div>
</template>
 
<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      // Firewood invoices (no quotation) go to firewood-invoice view
      const id = this.params.data.id;
      const hasQuotation = (this.params.data.idquotation_invoice != null && this.params.data.idquotation_invoice !== undefined) ||
        (this.params.data.quotation_no != null && this.params.data.quotation_no !== '');
      return hasQuotation ? "/invoice/" + id : "/firewood-invoice/" + id;
    },
    urlnull () {
      return "#"

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    },
    canAccessInvoice() {
      if (typeof window !== 'undefined' && window.localStorage) {
        const loginRoles = window.localStorage.getItem('login-roles');
        return loginRoles && loginRoles.toLowerCase().includes('invoice');
      }
      return false;
    }
  }
}
</script>
 